import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

import Link from '@material-ui/core/Link';
import classnames from 'classnames';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import FavoriteIcon from '@material-ui/icons/Favorite';
import ShareIcon from '@material-ui/icons/Share';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import ThumbUp from '@material-ui/icons/ThumbUpTwoTone';
import ThumbDown from '@material-ui/icons/ThumbDownTwoTone';
import { APIRoot, content_admin } from "variables/authentication.jsx";

import Api from 'services/api';

const VideosAPIRoot = "/videos";
const UsersAPIRoot = "/users";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#ef4340'
    },
    secondary: {
      main: '#4cba51',
      contrastText: '#fff'
    }
  },
});

const styles = theme => ({
  card: {
    maxWidth: 400,
    marginBottom: "30px",
    marginTop: "30px",
  },
  star: {
    background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  actions: {
    display: 'flex',
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  button: {
    margin: theme.spacing.unit,
  },
});

class ReportCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      report_data: props.report_data,
      expanded: false,
      srcUrl: undefined,
      thumbnailUrl: undefined,
      itemID: undefined,
      reporter: { username: "Unknown" },
      reporteeID: undefined,
      reportee: undefined,
      dialogOpen: false,
    };
    this.uploadVerdict = this.uploadVerdict.bind(this);
    this.loadContent();
    this.loadReporter();
  }

  handleExpandClick = () => {
    this.setState(state => ({ expanded: !state.expanded }));
  };


  async uploadVerdict(ok = true) {
    this.props.message("Note: This button currently does nothing. Upload the data to Reviewed Items when the reviewed items endpoint is ready! You can edit the file here: krikey-admin-panel/src/components/Card/ReportCard.jsx")
    /*
      ----------------------------
     |                            |
     | Upload reviewed item here  |
     |                            |
      ----------------------------
    */
  }

  openDialog = () => {
    this.setState({ dialogOpen: true });
  }

  closeDialog = () => {
    this.setState({ dialogOpen: false });
  };

  handleDelete = () => {
    this.setState({ dialogOpen: false });
    this.uploadVerdict(false).then((response) => {
      if (response && response.ok) {
        /*
          ----------------------------
         |                            |
         | Upload reviewed item here  |
         |                            |
          ----------------------------
        */
      }
    })
  };


  // TODO: current version does 3 api calls. Can reduce to one by adding associations in server
  async loadContent() {
    if (!this.state.report_data || this.state.report_data.item_type != "video") return;
    try {
      const url = VideosAPIRoot + '/' + this.state.report_data.item_id;
      const responseData = await Api({ endpoint: url });
      this.setState({
        srcUrl: responseData.download_url,
        thumbnailUrl: responseData.thumbnail_url,
        itemID: responseData.item_id,
        reporteeID: responseData.user_id,
      })
      this.loadReportee(responseData.user_id);
    } catch (e) {
      console.error(e)
    }
  }

  async loadReporter() {
    const url = UsersAPIRoot + '/' + this.state.report_data.reporting_user_id;
    try {
      const responseData = await Api({ endpoint: url })
      this.setState({ reporter: responseData })
    } catch (e) {
      console.error(e)
    }
  }

  async loadReportee(reporteeID) {
    const url = UsersAPIRoot + '/' + reporteeID;
    try {
      const responseData = await Api({ endpoint: url })

      this.setState({ reportee: responseData })
    } catch (e) {
      console.error(e)
    }

  }


  render() {
    const { classes } = this.props;
    var report_data = this.state.report_data || {}
    var description = report_data.reported_at ? "Reported on " + report_data.reported_at.split("T")[0] : "Unknown report date";
    //var subheader = "Reported by " + (this.state.reproter?this.state.reporter.id:"Unknown");
    var metadata1 = "Case ID: " + (report_data.id ? report_data.id : "Loading");
    var metadata2 = "Reportee ID: " + (this.state.reporteeID ? this.state.reporteeID : "Loading");
    var metadata3partial = (this.state.reportee ? (this.state.reportee.email ? this.state.reportee.email : "(Restricted Access)") : "Loading");
    var metadata3 = "Reportee email: " + metadata3partial;
    return (
      <Card className={classes.card}>
        <CardHeader
          color="secondary"
          subheader={"Reported by " + this.state.reporter.username}
        />
        {report_data.item_type == "video" && this.state.srcUrl ?
          <video controls height='180' width='100%' controls poster={this.state.thumbnailUrl} preload="none">
            <source src={this.state.srcUrl}
              type="video/mp4" />
          </video>
          :
          <Typography>
            {"  Loading content ..."}
          </Typography>
        }
        <CardContent>
          <Typography component="p">
            {description}
          </Typography>
        </CardContent>
        <MuiThemeProvider theme={theme}>
          <CardActions className={classes.actions} >

            <Button variant="contained"
              color="primary"
              disabled={localStorage.getItem('role') != content_admin}
              onClick={this.openDialog}
              fullWidth
            >
              <ThumbDown />
            </Button>


            <Button variant="contained"
              color="secondary"
              disabled={localStorage.getItem('role') != content_admin}
              onClick={this.uploadVerdict}
              fullWidth
            >
              <ThumbUp />
            </Button>

            <IconButton
              className={classnames(classes.expand, {
                [classes.expandOpen]: this.state.expanded,
              })}
              onClick={this.handleExpandClick}
              aria-expanded={this.state.expanded}
              aria-label="Show more"
            >
              <ExpandMoreIcon />
            </IconButton>
          </CardActions>
        </MuiThemeProvider>
        <Collapse in={this.state.expanded} timeout="auto" unmountOnExit>
          <CardContent>
            <Typography>
              {metadata3}
            </Typography>
            <Typography>
              {metadata2}
            </Typography>
            <Typography>
              {metadata1}
            </Typography>
          </CardContent>
        </Collapse>
        <Dialog
          open={this.state.dialogOpen}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Remove Content?"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              You are about to remove the following reported content from the Krikey platform. This action cannot be undone.


            </DialogContentText>
            <DialogContentText id="alert-dialog-description0">
              User Name: {this.state.reportee ? this.state.reportee.username : "Unknown"}
            </DialogContentText>
            <DialogContentText id="alert-dialog-description1">
              User Email: {metadata3partial}
            </DialogContentText>
            <DialogContentText id="alert-dialog-description2">
              {metadata1}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.closeDialog} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleDelete} color="secondary" autoFocus>
              Proceed
            </Button>
          </DialogActions>
        </Dialog>
      </Card>
    );
  }
}

ReportCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ReportCard);